import { SubtipoAtendimentoHistoricoClinico, TipoRegistroHistoricoClinico } from 'graphql/types.generated'
import { subtipoRecord } from 'view/atendimentos/detail/historico/model/model-historico'

import { FolhaRostoTagModel, VisitaAusenteOuRecusadaRecord } from './model'

export const ausenteOuRecusadaText = (tipoContato: TipoRegistroHistoricoClinico, tags: FolhaRostoTagModel[]) => {
  if (tipoContato === TipoRegistroHistoricoClinico.VISITA_DOMICILIAR) {
    const tag = tags?.find(
      (tag) =>
        tag?.label === subtipoRecord[SubtipoAtendimentoHistoricoClinico.CIDADAO_AUSENTE] ||
        tag?.label === subtipoRecord[SubtipoAtendimentoHistoricoClinico.VISITA_RECUSADA]
    )

    return VisitaAusenteOuRecusadaRecord[tag?.label]
  }
}
